import React from 'react';
import FilemanagerService from '@assets/services/FilemanagerService';
import {doBlockPage, doUnblockPage} from '@assets/js/input/load_page_helper';
import {handleError} from '@assets/middlewares/errorHandler';
import {AppError} from '@assets/core/AppError';

class FilesDownloadBtn extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownload = this.handleDownload.bind(this);
    }
    handleDownload = async () => {
        try {
            doBlockPage();
            const {fieldName, rowId, tableId} = this.props;
            const filemanagerService = new FilemanagerService();
            const result = await filemanagerService.generateArchiveByField({fieldName, rowId, tableId});
            if (result.errors) {
                throw new AppError(result.errors);
            }
            await filemanagerService.downloadArchive(result.file_name);
        } catch (e) {
            handleError(e);
        } finally {
            doUnblockPage();
        }
    };
    render() {
        const {handleDownload} = this;
        const {files} = this.props;
        return (
            <button type="button" className="btn btn-info btn-xs" onClick={() => {handleDownload()}}
                    disabled={Object.keys(files).length === 0}>
                <span className="glyphicon glyphicon-download-alt" />
                &nbsp;
                Скачать все файлы
            </button>
        );
    }
}
export default FilesDownloadBtn;
